import moment from 'moment'
import * as types from '../mutation-types'
import C from '../../constants'

const state = {
  dateRange: [ moment().subtract(60, 'days').format(C.M_FMT_MS), moment().format(C.M_FMT_MS) ]
}

const getters = {
  dateRange: state => state.dateRange
}

const actions = {
}

const mutations = {
  [types.FILTER_DATE_RANGE] (state, dateRange) {
    state.dateRange = dateRange
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filterDateRange.js